<script>
 import { getFormats } from './utils.js';
 import { download_svg } from './svgs.js';
 export let book;
 let tooltip = false;

 function fadeLibrarian() {
     tooltip = true;
     setTimeout(() => tooltip = false, 3000)
 }
</script>

<style>
 .cover {
     min-height: 16em;
     background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2063.5%2084.7%22%20height%3D%22320%22%20width%3D%22240%22%3E%3Cpath%20d%3D%22M5.292%205.292h52.917v74.083H5.292z%22%20fill%3D%22%23e0e0e0%22%20paint-order%3D%22stroke%20fill%20markers%22%2F%3E%3Cpath%20d%3D%22M10.6%2010.6h42.3v63.5H10.6z%22%20fill%3D%22%23c0c0c0%22%20paint-order%3D%22stroke%20fill%20markers%22%2F%3E%3Cpath%20d%3D%22M15.8%2015.8h31.8v53H15.8z%22%20fill%3D%22%23a0a0a0%22%20paint-order%3D%22stroke%20fill%20markers%22%2F%3E%3C%2Fsvg%3E");
     background-repeat: no-repeat;
     background-size: cover;
 }
</style>

<div on:mouseenter={fadeLibrarian} class="cover monocle:w-full phone:w-1/2 phablet:w-1/3 tablet:w-1/4 laptop:w-1/6 suv:w-1/12 relative bg-white border-white border-2">
    <img title="show book card" on:click="{() => window.location.hash = `#/book/${book._id}`}" class="w-full min-h-full text-white" src={book.library_url+book.cover_url} alt="" />
    <div class="bg-black text-white absolute top-0 mt-4 font-bold text-base suv:text-sm w-full">
        <a title="show book card" href="#/book/{book._id}" class="pl-2 block hover:underline">{book.title}&nbsp;</a>
        <div class="pl-2 not-italic text-base suv:text-sm block">
            {#each book.authors as author, i}
                {#if i+1 < 4 }<a title="search in authors" href="#/search/authors/{author}" class="hover:underline">{author}</a>{/if}{#if i+1 !== book.authors.length && i+i < 4 },&nbsp;{:else if i+i === 4 }&nbsp;et al.{/if}{/each}
        </div>
    </div>
    <div class="bg-black text-white absolute w-full bottom-0 pl-2">
        {#if tooltip}
            <div class="pb-2">via <a title="search in librarians" class="hover:underline cursor-pointer" href="#/search/librarian/{book.librarian}">{book.librarian}</a></div>
        {/if}
        {#if book.formats != undefined && book.formats.length != 0 }
            {#each getFormats(book) as format}
                <a class="hover:underline inline-block p-1" href="{format.url}" title="{format.size}">
                    <img class="w-4 inline-block" alt="dl" src="{download_svg}"><i>{format.title}</i></a>
            {/each}
        {:else}
            <span class="text-black">.</span>
        {/if}
    </div>
</div>
